import React, { useState, useCallback, useContext, useRef, useEffect } from 'react';
import Account from '../../API/APIServices/Account';
import MyContext from '../MyContext';
import Swal from "sweetalert2";
import ConvertInvoiceAndSynchDataController from '../../API/APIServices/ConvertInvoiceAndSynchDataController';



function ProductsAndGroupsSynchronization({ setIsDestinationShow, setLoading, currentFirmId, companyList }) {

    const { debounce } = useContext(MyContext);
    const dropDownRef = useRef(null);



    const [synchronizeType, setSynchronizeType] = useState(1);
    const [productGroup, setProductGroup] = useState("");
    const [productGroupId, setProductGroupId] = useState(0);
    const [filteredProductGroup, setFilteredProductGroup] = useState([]);
    const [isDropdownProductGroup, setIsDropdownProductGroup] = useState(false);



    function handleSynchronizeTypeChange(e) {

        setProductGroupId(0);
        setProductGroup("");
        const value = Number(e.target.value);
        setSynchronizeType(value);
    }


    const fetchSuggestions = async (name, value, GroupId, MasterType) => {

        const filteredData = {
            MasterType: MasterType,
            GroupWiseSuggestion: true,
            GroupId: GroupId,
            search_str: value,
            PageNumber: 1,
            PageSize: 50,
        };

        try {
            const SearchItem = await Account.GetAccountListForAutoSuggestion(
                filteredData
            );

            if (SearchItem) {
                return SearchItem;
            } else {
                return [];
            }
        } catch (error) {
            console.error("Error fetching account suggestions:", error);
            return [];
        }
    };


    const debouncedFetchProductGroupSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 3);

            setFilteredProductGroup(SearchItem);
            setIsDropdownProductGroup(true);

        }, 500),
        []
    );

    const handleProductGroupChange = (e) => {

        setProductGroup(e.target.value);
        setProductGroupId(0);
        debouncedFetchProductGroupSuggestions("ProductGroup", e.target.value, '');
    }

    const handleProductGroupSelection = async (id, name) => {

        console.log(id, name)
        setProductGroup(name);
        setProductGroupId(id);
        setIsDropdownProductGroup(false);
    };

    useEffect(() => {

        function handleClickOutside(event) {

            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setIsDropdownProductGroup(false);
            }
        }


        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);

    async function handleProceed() {

        console.log({ synchronizeType, productGroupId });

        if (synchronizeType == 2 && productGroupId == 0) {
            Swal.fire({
                icon: "warning",
                title: "Please select product group!",
                text: "",
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true,
                width: "250px",
                customClass: {
                    title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                    popup: "swal2-custom-popup",
                    htmlContainer: "swal2-custom-text",
                    icon: "swal2-custom-icon",
                },
            });

            return;
        }

        const selectedDestinationCompany = companyList.filter(item => item.isSelected);


        if (selectedDestinationCompany.length == 0) {

            Swal.fire({
                icon: "warning",
                title: "Please select destination companies!",
                text: "",
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true,
                width: "250px",
                customClass: {
                    title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                    popup: "swal2-custom-popup",
                    htmlContainer: "swal2-custom-text",
                    icon: "swal2-custom-icon",
                },
            });

            return;
        }

        if (!currentFirmId) {
            Swal.fire({
                icon: "warning",
                title: "Please select current firm!",
                text: "",
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true,
                width: "250px",
                customClass: {
                    title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                    popup: "swal2-custom-popup",
                    htmlContainer: "swal2-custom-text",
                    icon: "swal2-custom-icon",
                },
            });

            return;
        }

        try {

            const synchronizedFirmName = [];
            const unSynchronizedFirmName = [];

            setLoading(true);
            for (let i = 0; i < selectedDestinationCompany.length; i++) {

                try {

                    const group_id = synchronizeType === 1 ? 0 : productGroupId;

                    const data = { MasterType: 3, GroupId: group_id, FromBranch_Id: currentFirmId, ToBranch_Id: selectedDestinationCompany[i].id };

                    const result = await ConvertInvoiceAndSynchDataController.SyncItemMasterBetweenDBs2(data);

                    if (result.data?.isSuccess) {
                        synchronizedFirmName.push(selectedDestinationCompany[i].name);
                    } else {
                        unSynchronizedFirmName.push(selectedDestinationCompany[i].name);
                    }

                } catch (error) {
                    console.log(`Error in product and group synchronization for company ${selectedDestinationCompany[i].name}`);
                    unSynchronizedFirmName.push(selectedDestinationCompany[i].name);
                }
            }

            console.log("synchronizedFirmName", synchronizedFirmName)
            console.log("unSynchronizedFirmName", unSynchronizedFirmName)

            let text_response = "";

            if (synchronizedFirmName.length > 0) {

                text_response += synchronizedFirmName.join(", ") + " synchronized successfully. ";
            }

            if (unSynchronizedFirmName.length > 0) {

                text_response += unSynchronizedFirmName.join(", ") + " un-synchronized. ";
            }

            Swal.fire({
                icon: "info",
                title: "Synchronization information",
                text: text_response,
                timer: 5000,
                showConfirmButton: false,
                timerProgressBar: true,
                width: "250px",
                customClass: {
                    title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                    popup: "swal2-custom-popup",
                    htmlContainer: "swal2-custom-text",
                    icon: "swal2-custom-icon",
                },
            });

        } catch (error) {
            console.log("Error in product and group synchronization!", error);
            Swal.fire({
                icon: "error",
                title: "Product and Group synchronization Failed!",
                text: "",
                timer: 10000,
                showConfirmButton: false,
                timerProgressBar: true,
                width: "250px",
                customClass: {
                    title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                    popup: "swal2-custom-popup",
                    htmlContainer: "swal2-custom-text",
                    icon: "swal2-custom-icon",
                },
            });

        }

        setLoading(false);
    }


    return (
        <div onClick={() => setIsDestinationShow(false)} className='synchronize-master-and-setting-toggle-container'>

            <p style={{ color: "red" }}>This process is necessary before you do 'Stock Transfer'.</p>


            <div style={{ display: "flex", alignItems: "center" }}>


                <div className="input-box-m11" style={{ width: "200px" }}>
                    <select value={synchronizeType} onChange={handleSynchronizeTypeChange} className="modify_im_input mode_category" type="text" required>
                        <option value={1}>Synchronize All</option>
                        {/* <option value={2}>Synchronize Group Wise</option> */}

                    </select>
                    <label class="ItemMasterLabelFix" ></label>

                </div>



                <div ref={dropDownRef} style={synchronizeType === 1 ? { display: "none", width: "200px" } : { width: "200px" }} className="group_head">

                    <input style={{ borderRadius: "4px" }} value={productGroup} onChange={handleProductGroupChange} onClick={() => {

                        debouncedFetchProductGroupSuggestions("ProductGroup", productGroup, '')

                    }} placeholder="Product Group" type="text" className="bill_panel_input" />

                    {isDropdownProductGroup && (
                        <ul
                            style={{ position: "absolute", top: "35px" }}
                            className="ItemmasterDuggestionsaleinvoice"
                        // ref={suggestionBoxRef}
                        >
                            {filteredProductGroup.map((pGroup, index) => (
                                <li
                                    key={index}
                                    // ref={(el) =>
                                    //     (itemRefs.current[index] = el)
                                    // }
                                    onClick={() =>
                                        handleProductGroupSelection(
                                            pGroup.id,
                                            pGroup.name
                                        )
                                    }

                                >
                                    {pGroup.name}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <button onClick={handleProceed} style={{ marginLeft: "0px" }} className="product-price-account-wise-delete-button">Proceed</button>

            </div>


            <div className='synchronize-master-and-setting-toggle-container-heading'>Products and there groups</div>
        </div>
    )
}

export default ProductsAndGroupsSynchronization;